export const ROUND_TRIP = "round_trip";
export const ONE_WAY = "one_way";
export const MULTICITY = "multicity";

export const FLIGHT_TYPE_DOMESTIC = 'DOMESTIC';
export const FLIGHT_TYPE_INTERNATIONAL = 'INTERNATIONAL';

export const FLIGHT_INDICATOR = {
    "OW" : "POR TRAMO",
    "RT": "IDA Y VUELTA"
}

export const TRIP_TYPE_OPTIONS = [
  { type: ROUND_TRIP, label: "Ida y vuelta" },
  { type: ONE_WAY, label: "Solo ida" },
  { type: MULTICITY, label: "Múltiples destinos" },
];

export const TERMINAL_ID = "6163747";

export const URL_PRINCIPAL = 'booking.pasajesbaratos.com';
export const URL_FLIGHTS = 'booking.pasajesbaratos.com/vuelos/pro';

export const API_URL_OFFERS = '/costamar-api/offers';
